import { render, staticRenderFns } from "./Step1.vue?vue&type=template&id=274483d3&scoped=true&"
import script from "./Step1.vue?vue&type=script&lang=ts&"
export * from "./Step1.vue?vue&type=script&lang=ts&"
import style0 from "./Step1.vue?vue&type=style&index=0&id=274483d3&lang=scss&scoped=true&"
import style1 from "./Step1.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274483d3",
  null
  
)

export default component.exports